import { Icons } from "assets/icons";
import FilterBar from "components/common/FilterBar";
import NoDataFound from "components/common/NoDataFound";
import Paginations from "components/common/Paginations";
import { StatusBadge } from "components/common/StatusBadge";
import DataTable from "components/common/table/DataTable";
import { usePermission } from "hooks/usePermission";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { formatUTCDate } from "utils/utils";

const STATIC_ANPR_LOGS = [
  {
    _id: "anpr_001",
    plateNumber: "ABC-1234",
    vehicleMake: "Toyota Camry",
    memberName: "James Harrington",
    membershipPlan: "Gold",
    entryTime: "2025-03-28T08:14:22Z",
    exitTime: "2025-03-28T08:27:45Z",
    washType: "Full Wash",
    status: 1,
  },
  {
    _id: "anpr_002",
    plateNumber: "XYZ-5678",
    vehicleMake: "Honda Civic",
    memberName: "Sarah Mitchell",
    membershipPlan: "Silver",
    entryTime: "2025-03-28T09:02:10Z",
    exitTime: "2025-03-28T09:14:30Z",
    washType: "Basic Wash",
    status: 1,
  },
  {
    _id: "anpr_003",
    plateNumber: "DEF-9012",
    vehicleMake: "Ford F-150",
    memberName: "Unknown",
    membershipPlan: "N/A",
    entryTime: "2025-03-28T10:45:00Z",
    exitTime: null,
    washType: "N/A",
    status: 0, // unrecognized plate
  },
  {
    _id: "anpr_004",
    plateNumber: "GHI-3456",
    vehicleMake: "BMW 3 Series",
    memberName: "Robert Chen",
    membershipPlan: "Platinum",
    entryTime: "2025-03-29T07:30:15Z",
    exitTime: "2025-03-29T07:48:00Z",
    washType: "Premium Wash",
    status: 1,
  },
  {
    _id: "anpr_005",
    plateNumber: "JKL-7890",
    vehicleMake: "Chevrolet Malibu",
    memberName: "Emily Torres",
    membershipPlan: "Gold",
    entryTime: "2025-03-29T11:20:00Z",
    exitTime: "2025-03-29T11:33:10Z",
    washType: "Full Wash",
    status: 1,
  },
];

const ANPRLogs = () => {
  const { t } = useTranslation();
  const { noPlans } = Icons || {};
  const navigate = useNavigate();
  const { canAction } = usePermission();
  const { canView } = canAction("vehicles");

  const [keyword, setKeyword] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const filtered = STATIC_ANPR_LOGS.filter(
    (log) =>
      log.plateNumber.toLowerCase().includes(keyword.toLowerCase()) ||
      log.memberName.toLowerCase().includes(keyword.toLowerCase())
  );

  const columns = useMemo(
    () => [
      {
        header: t("Plate Number"),
        key: "plateNumber",
        render: (value) => <strong>{value}</strong>,
      },
      {
        header: t("Vehicle"),
        key: "vehicleMake",
      },
      {
        header: t("Member"),
        key: "memberName",
      },
      {
        header: t("Plan"),
        key: "membershipPlan",
      },
      {
        header: t("Wash Type"),
        key: "washType",
      },
      {
        header: t("Entry Time"),
        key: "entryTime",
        render: (value) => (
          <div className="ltr_text">{formatUTCDate(value)}</div>
        ),
      },
      {
        header: t("Exit Time"),
        key: "exitTime",
        render: (value) =>
          value ? (
            <div className="ltr_text">{formatUTCDate(value)}</div>
          ) : (
            <span className="text-muted">—</span>
          ),
      },
      {
        header: t("Status"),
        key: "status",
        render: (value) => <StatusBadge status={value} t={t} />,
      },
    ],
    [t]
  );

  if (!canView) return null;

  return (
    <div className="page-content addons_page">
      <h4 className="page_title mb-3">{t("ANPR Logs")}</h4>
      <FilterBar
        keyword={keyword}
        setKeyword={setKeyword}
        keywordPlaceholder={t("Search by plate or member")}
        filters={[]}
        selectedFilters={{ keyword }}
        onSearch={() => {}}
        onReset={() => setKeyword("")}
        isBtn={false}
        isDateRange={false}
      />

      {filtered.length === 0 && (
        <NoDataFound title={t("No ANPR logs found")} icon={noPlans} />
      )}

      {filtered.length > 0 && (
        <>
          <DataTable columns={columns} data={filtered} t={t} />
          <Paginations
            currentPage={currentPage}
            totalPages={1}
            totalCount={filtered.length}
            onPageChange={setCurrentPage}
          />
        </>
      )}
    </div>
  );
};

export default ANPRLogs;